import React from 'react'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import { fetchMobileTask } from '../api'
import { getUpSellIconType } from '../shared/enums/upsell-icon-type'
import { getIntervalParser } from '../shared/enums/interval-enum-parser'
import WeekPicker from '../weekpicker/weekpicker'
import './order-upsell-modal.css'

export default React.createClass({
  getInitialState: function () {
    return {
      data: {
        interval: '',
        packageType: '',
        price: '',
        serviceStartDate: ''
      },
      nowBtnActive: true
    }
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.card !== '' && nextProps.show === true) {
      let upsellType = getUpSellIconType(nextProps.card.upSellType)
      let searchAddress = nextProps.address
      if (nextProps.newAddress) {
        searchAddress = nextProps.newAddress
      }
      fetchMobileTask(upsellType.prettify, searchAddress).then((data) => {
        let intervalParsed = getIntervalParser(data.data[0].interval)
        let myData = {
          interval: intervalParsed.capitalizedText,
          packageType: data.data[0].packageType,
          price: data.data[0].price,
          serviceStartDate: ''
        }
        this.setState({
          data: myData,
          nowBtnActive: true
        })
      })
    }
  },

  nowBtnClick: function () {
    let data = {...this.state.data}
    data.serviceStartDate = ''
    this.setState({
      data: data,
      nowBtnActive: true
    })
  },

  laterBtnClick: function () {
    this.setState({
      nowBtnActive: false
    })
  },

  setSelectStartDate: function (date) {
    const newDate = new Date(date)
    let data = {...this.state.data}
    data.serviceStartDate = `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`
    this.setState({
      data: data
    })
  },

  render: function () {
    let color, newTitle, hr
    const nowLaterBtnActiveColor = 'cerulean-blue-color'
    const nowLaterBtnDefaultColor = 'medium-gray-color'

    const {streetAddress} = this.props
    const {nowBtnActive} = this.state

    switch (this.props.card.upSellType) {
      case 'LAWNMOWING_TASK':
        color = 'lawnmowing-background'
        hr = 'mowlawn-hr'
        newTitle = 'Lawn Mowing'
        break
      case 'FERTILIZATION_TASK' :
        color = 'fertilization-background'
        hr = 'fertilizelawn-hr'
        newTitle = 'Lawn Fertilization'
        break
      case 'SPRING_SEASONAL_TASK' :
        color = 'springcleanup-background'
        hr = 'springcleanup-hr'
        newTitle = 'Spring Cleanup'
        break
      case 'AERATION_TASK' :
        color = 'aeration-background'
        hr = 'aeratelawn-hr'
        newTitle = 'Lawn Aeration'
        break
      case 'FALL_SEASONAL_TASK':
        color = 'fallcleanup-background'
        hr = 'fallcleanup-hr'
        newTitle = 'Fall Cleanup'
        break
      default:
        break
    }
    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upsell-modal-size'>
          <Modal.Header closeButton className='concrete-gray-background'>
            <div className='upsell-grid-container'>
              <div className='upsell-card-container row'
                   style={{margin: 'auto', width: '90%', textAlign: 'center', marginTop: 20}}>
                <div className={'hidden-xs ' + color} style={{
                  color: 'white',
                  background: color,
                  width: 350,
                  height: 'auto',
                  margin: 'auto',
                  marginBottom: 10,
                  paddingTop: 10
                }}>
                  <h6 style={{fontWeight: 300, fontSize: 24, color: 'white'}}><span
                    style={{fontWeight: 500}}>{newTitle}</span> for</h6>
                  <p style={{fontSize: 24}}>{streetAddress}</p>
                  <hr className={`card-hr ${hr}`}/>
                  <div style={{fontSize: 14, marginBottom: 20}}
                       dangerouslySetInnerHTML={{__html: this.props.card.description}}/>
                  <div style={{fontWeight: 100}}>
                    <div className={'task-type center no-text upsell-task-icon'} style={{height: '54px', width: '54px', margin: '0 10px 0 0', display: 'inline-block', position: 'relative', top: '10px'}}>
                      <div className={`${this.props.icon}-circle`} style={{height: '54px', width: '54px', margin: '0'}}/>
                    </div>
                    <b style={{fontSize: 46}}>${this.state.data.price}</b>/service
                  </div>
                  <br/>
                  <div style={{paddingBottom: '15px'}}>{this.state.data.interval} {newTitle}</div>
                </div>
                <div className={'visible-xs ' + color} style={{
                  color: 'white',
                  background: color,
                  width: 250,
                  height: 106,
                  margin: 'auto',
                  marginBottom: 40,
                  paddingTop: 10
                }}>
                  <span style={{fontWeight: 100}}><b style={{fontSize: 46}}>${this.state.data.price}</b>/service</span>
                  <br/>
                  <span>{this.state.data.interval} {newTitle}</span>
                </div>
              </div>
              <div className='row text-center'>
                <h5 className='sushi-color'>When do you want your service to begin?</h5>
              </div>
              <div className='upsell-nowlater-container row text-center'>
                <div className='col-lg-2 col-lg-offset-4'>
                  <button id='upsell-modal-now-btn' onClick={this.nowBtnClick}
                          className={nowBtnActive ? `${nowLaterBtnActiveColor} active` : nowLaterBtnDefaultColor}>Now
                  </button>
                </div>
                <div className='col-lg-2'>
                  <button id='upsell-modal-later-btn' onClick={this.laterBtnClick}
                          className={nowBtnActive ? nowLaterBtnDefaultColor : `${nowLaterBtnActiveColor} active`}>Later
                  </button>
                </div>
              </div>
              <div className='row bottom-row'>
                <div>
                  {!nowBtnActive &&
                  <div className='upsell-calendar-container col-lg-6'>
                    <div>
                      <p>Select the week you want to begin service:</p>
                      <WeekPicker setSelectStartDate={this.setSelectStartDate}/>
                    </div>
                  </div>
                  }
                  <div className={nowBtnActive ? 'col-lg-6 col-lg-offset-3' : 'col-lg-6'}>
                    <div className='upsell-additionals-container row'>
                      <hr/>
                      <div className='row'>
                        <p className='col-lg-12 sushi-color' style={{marginBottom: 10, paddingBottom: 0}}>
                          I'd like to add special instructions
                        </p>
                        <FormGroup style={{margin: '15px 0 0 0'}}>
                          <FormControl className='faq-text' componentClass='textarea' id='comment'
                                       placeholder='Do you have gates with codes, or any pets we need to know about? Add any extra information here if necessary.'
                                       style={{height: 120, paddingTop: 20}}/>
                        </FormGroup>
                      </div>
                      <hr/>
                    </div>
                    <div className='upsell-continue-container row'>
                      <p>Every one of TaskEasy's contractors must pass a screening and carry insurance to be part of our
                        elite team of service professionals.</p>
                      <button id='upsell-modal-continue-btn' className='btn btn-success center-block' type='submit'
                              onClick={() => this.props.openPayment(this.props, this.state.data, document.getElementById('comment').value)}
                              style={{marginBottom: '10px', fontWeight: 300, fontSize: 'larger'}}>Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/order-upsell-modal.jsx